import React from 'react';
import { MediaPreview } from './MediaPreview';

export const MessageBubble = ({ msg }) => {
  const isAgent = msg.sender === 'agent';

  const renderStatusIcon = (status) => {
    switch (status) {
      case 'sent': return <span className="text-gray-400 text-[10px] ml-1 font-bold">✓</span>;
      case 'delivered': return <span className="text-gray-400 text-[10px] ml-1 font-bold">✓✓</span>;
      case 'read': return <span className="text-blue-500 text-[10px] ml-1 font-bold drop-shadow-sm">✓✓</span>;
      default: return null;
    }
  };

  const isOnlyMedia = msg.mediaUrl && (!msg.content || msg.content === '[Media]' || msg.content === '[Received image]' || msg.content === '[Received document]');

  return (
    <div className={`flex ${isAgent ? 'justify-end' : 'justify-start'} group`}>
      <div 
        className={`max-w-[85%] md:max-w-[70%] rounded-2xl px-4 py-2.5 relative shadow-sm transition-all hover:shadow-md ${
          isAgent 
            ? 'bg-[#DCF8C6] text-gray-900 rounded-tr-sm border border-[#c1eaa3]' 
            : 'bg-white text-gray-900 rounded-tl-sm border border-gray-100'
        }`}
      >
        {msg.mediaUrl && (
          <MediaPreview type={msg.type} url={msg.mediaUrl} msg={msg} />
        )}
        
        {!isOnlyMedia && msg.content && (
          <p className="whitespace-pre-wrap break-words text-[15px] leading-relaxed font-normal">
            {msg.content}
          </p>
        )}
        
        <div className={`flex items-center justify-end gap-1 mt-1 mb-[-4px] ${isOnlyMedia ? 'mt-2' : ''}`}>
          <span className="text-[10px] text-gray-500 font-medium">
            {new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </span>
          {isAgent && renderStatusIcon(msg.status)}
        </div>
        
        {isAgent && msg.agentId && (
          <div className="absolute -bottom-5 right-0 opacity-0 group-hover:opacity-100 transition-opacity text-[10px] text-gray-400 font-medium bg-white/80 px-2 py-0.5 rounded-full shadow-sm border border-gray-100 whitespace-nowrap">
            Sent by {msg.agentId.firstName || 'Agent'}
          </div>
        )}
      </div>
    </div>
  );
};
